import { render, staticRenderFns } from "./dialog-reset-password.vue?vue&type=template&id=50bbcaa4&scoped=true&"
import script from "./dialog-reset-password.vue?vue&type=script&lang=ts&"
export * from "./dialog-reset-password.vue?vue&type=script&lang=ts&"
import style0 from "./dialog-reset-password.vue?vue&type=style&index=0&id=50bbcaa4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bbcaa4",
  null
  
)

export default component.exports